<template >
  <v-container fluid class="uspbar my-0" v-if="siteSettings.Usp">
    <v-container class="pa-0">
      <v-row class="py-2">
        <v-col
          v-for="(usp, i) in siteSettings.Usp"
          :key="i"
          class="py-0"
          cols="6"
          sm="3"
          md="3"
          lg="3"
          xl="3"
        >
          <v-row no-gutters  class="fill-height" >
            <v-col cols="3" sm="4" md="3" lg="2"  class="pr-2 py-2 fill-height">
              <v-sheet class="fill-height">
                <v-container class="pa-0 fill-height">
                  <SvgIconPublic v-if="usp.IconPath" class="pr-1 icon" :sizeIcon="iconSize" :url="usp.IconPath"/>
                </v-container>
              </v-sheet>
            </v-col>
            <v-col v-if=" usp.Title && usp.AltText" cols="9" sm="8" md="9" lg="10" :title="usp.AltText" class="fill-height">
              <v-sheet class="fill-height">
                <v-container class="pa-0 fill-height title" >
                  {{ usp.Title }}
                </v-container>
              </v-sheet>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script setup>
import SvgIconPublic from "@/components/Base/SvgIconPublic.vue";

const siteSettings = useSiteSettingsStore();

let tooltips = ref([]);
let closeOnContentClick = true // Prevent console warning in develop mode closeOnContentClick expect boolen got string

const iconSize = computed(() => {
  switch (useNuxtApp().$vuetify.display.mobile._object.name) {
    case "xs":
      return 25;
    case "sm":
      return 29;
    case "md":
      return 29;
    case "lg":
      return 33;
    case "xl":
      return 36;
    case "xxl":
      return 39;
    default:
      return 36;
  }
});
</script>
